import axios from './utils/axios';
import { utils } from 'gipsy-misc';

var cancelTokens = {};

export var get = function get(assignee) {
  cancelTokens.get = require('axios').CancelToken.source();
  var endpoint = '/team/watched-tasks';
  var params = {};
  if (assignee) {
    if (assignee.userId) {
      params.userId = assignee.userId;
    } else {
      params.email = assignee.email;
    }
  }
  endpoint = utils.request.appendToUrl(endpoint, params);
  return axios.get(endpoint, { cancelToken: cancelTokens.get.token });
};

export var getArchive = function getArchive(assignee, lastSortKey, limit) {
  cancelTokens.getArchive = require('axios').CancelToken.source();
  var endpoint = '/archive/watched-tasks';
  var params = {};
  params.lastSortKey = lastSortKey;
  params.limit = limit;
  if (assignee) {
    if (assignee.userId) {
      params.userId = assignee.userId;
    } else {
      params.email = assignee.email;
    }
  }

  endpoint = utils.request.appendToUrl(endpoint, params);
  return axios.get(endpoint, { cancelToken: cancelTokens.getArchive.token });
};

export var getTeamMembers = function getTeamMembers() {
  var endpoint = '/team/assignees';
  return axios.get(endpoint);
};

export var addTeamMembers = function addTeamMembers(members) {
  var endpoint = '/team/assignees';
  return axios.post(endpoint, members);
};

export var removeTeamMembers = function removeTeamMembers(teamMember) {
  var endpoint = '/team/assignees';
  var params = {};
  if (teamMember.userId) {
    params.userId = teamMember.userId;
  } else {
    params.email = teamMember.email;
  }
  endpoint = utils.request.appendToUrl(endpoint, params);
  return axios.delete(endpoint);
};

export var cancel = function cancel(method) {
  if (cancelTokens[method] && cancelTokens[method].cancel) {
    cancelTokens[method].cancel();
  }
};
//# sourceMappingURL=teamlist.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/teamlist.js
// module id = 1088
// module chunks = 0